import { createSlice } from '@reduxjs/toolkit';

// Define the initial state
const initialState = {
  data: null,
  loading: false,
  error: null,
};

// // Create a slice
export const appDetailSlice = createSlice({
  name: 'appDetail',
  initialState,
  reducers: {
    fetchDataStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDataSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDataFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const { fetchDataStart, fetchDataSuccess, fetchDataFailure } = appDetailSlice.actions;
export default appDetailSlice.reducer;